import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propBool, propStr, propFunc, propShape, propOneOf, } from '../../../../helpers/custom-prop-types';
import SlideSearchRegistrationFormInner from './SlideSearchRegistrationFormInner';
/**
 * PROFFIT SEARCHへの登録や、トライアル開始などを行うためのフォーム
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SlideSearchRegistrationForm = (props) => {
    const { canRegistrationTrial, error, form, handleSubmit, kanaRef, submitting, userMode, } = props;
    return (_jsx(SlideSearchRegistrationFormInner, { error: error, form: form, handleSubmit: handleSubmit, headerDescriptionListStyleText: '自動更新・料金が発生することはありません', headerDescriptionText: '無料トライアルの期間は全機能をご利用いただけます', headerText: '保有スライドをフル活用する\n新しい資料作成を体験しませんか？', kanaRef: kanaRef, submitText: canRegistrationTrial
            ? '15日間 無料で試してみる'
            : 'スタンダードプランを申込む', submitting: submitting, userMode: userMode }));
};
SlideSearchRegistrationForm.propTypes = {
    canRegistrationTrial: propBool().isRequired,
    error: propStr(),
    form: propStr(),
    handleSubmit: propFunc(),
    kanaRef: propShape().isRequired,
    submitting: propBool(),
    userMode: propOneOf(['guest', 'client', 'free_professional', 'professional'])
        .isRequired,
};
SlideSearchRegistrationForm.defaultProps = {
    error: undefined,
    form: '',
    handleSubmit: null,
    submitting: false,
};
export default SlideSearchRegistrationForm;
